// extracted by mini-css-extract-plugin
export var colorStyle = "TestConsoleLink-module__colorStyle___UAP8V";
export var link = "TestConsoleLink-module__link___TLbxR";
export var linkBig = "TestConsoleLink-module__linkBig___iJZv4";
export var linkContainer = "TestConsoleLink-module__linkContainer___ryOsW";